import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Organization User List Config"})
export class UserListConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine Options"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize?: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/UserListConfig.ts